import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
//import { Input, Icon, Button, Label, Form } from 'semantic-ui-react';
// import PeriodInput from 'widgets/form/period-input';
import TailwindPeriodInput from 'widgets/form/period-input-tw';
import { DateTimePeriod, NewEventSupportPositionsDto, EventPositionDto, TravelRangeDto } from 'stores/events/events-store';
import { UserDto } from 'stores/users/users-store';
import { DatePeriod } from 'site/pages/landing-pages/shared-scheduler-components/events/scheduler-period-service';
import { ReducerType, useStateReducer } from 'utils/react-custom-hooks';
import TailwindProfessionEditor from 'widgets/bussiness/profession-editor-tw';
import TailwindEventNewModelPositionComponent from './tailwind-new-event-model-position-component';
// import { DurationInput } from 'widgets/form/durationInput';
// import { MoneyInput } from 'widgets/form/moneyInput';
import moment from 'moment';
import { Fragment, useEffect } from 'react';
import TailwindPatternMachines from 'site/pages/shared/events-and-requests/pattern-machines-tw';
import { PatternMachinesViewModel } from 'site/pages/shared/events-and-requests/pattern-machines';
import { ItemReference } from 'stores/dataStore';
import { EventFormViewModel } from 'stores/events/event-form-store';
import TailwindChooseStudentsView from 'widgets/form/choose-students-form-tw';
import { shouldHideWorkingManHours, shouldHideWorkingDaysIndicator } from 'site/utils/event-types';

interface TailwindNewInfoSupportDetailedProps extends WithTranslation, NewEventSupportPositionsDto {
  readonly: boolean;
  onChange: (values: NewEventSupportPositionsDto) => void;
  onNewPosition: (newUser: UserDto, dates: DatePeriod) => void;
  isHideEditButton: boolean;
  //eventFormStore?: EventFormStore;
  event: EventFormViewModel;
}

interface TailwindNewInfoSupportDetailedState {
  showEmployeeSelectionModal: boolean;
  newPosition: boolean;
  userChangeIndex: number;
  arePlannedDaysCompleted: boolean;
  warningText: string;
}

const getDefaultValues = (): TailwindNewInfoSupportDetailedState => ({
  showEmployeeSelectionModal: false,
  newPosition: false,
  userChangeIndex: -1,
  arePlannedDaysCompleted: true,
  warningText: ''
});

const TailwindNewInfoSupportDetailed: React.FC<TailwindNewInfoSupportDetailedProps> = props => {
  const {
    supportPositionRoleId,
    patternId,
    patternName,
    machineModels,
    requestedManDays,
    requestedWorkingManHours,
    theoreticalCost,
    requestEndDate,
    requestStartDate,
    eventNewModelPositions,
    t,
    onChange,
    onNewPosition,
    //eventFormStore,
    event,
    ...rest
  } = props;

  const { positionsRequested, id, readonly, isHideEditButton } = rest;

  const [{ showEmployeeSelectionModal, newPosition, userChangeIndex, arePlannedDaysCompleted, warningText }, setState] = React.useReducer<
    ReducerType<TailwindNewInfoSupportDetailedState>,
    TailwindNewInfoSupportDetailedState
  >(useStateReducer, getDefaultValues(), getDefaultValues);

  const initialItem = {
    id,
    supportPositionRoleId,
    patternId,
    patternName,
    machineModels,
    requestedManDays,
    requestedWorkingManHours,
    theoreticalCost,
    positionsRequested,
    eventNewModelPositions,
    requestEndDate,
    requestStartDate
  };

  const myPattern = patternId ? ({ id: patternId, title: patternName ?? '' } as ItemReference) : null;

  const myMachines = (machineModels || []).map(m => ({
    cluster: m.machineRelatedClusterId ? { id: m.machineRelatedClusterId, title: m.machineRelatedClusterName } : null,
    equipmentType: m.equipmentTypeId ? { id: m.equipmentTypeId, title: m.equipmentTypeName } : null,
    oem: m.oemId ? { id: m.oemId, title: m.oemName } : null,
    machineModel: m.machineModelId ? { id: m.machineModelId, title: m.machineModelName } : null,
    machineUnits: m.machineUnitRequestMachines,
    plcTypes: m.plcTypeRequestMachines,
    hasAvailablePlcTypes: m.hasAvailablePlcTypes
  }));

  const patternMachines: PatternMachinesViewModel = { pattern: myPattern, machines: myMachines };

  const hideWorkingManHours = shouldHideWorkingManHours(event?.eventType?.name);
  const hideWorkingDaysIndicator = shouldHideWorkingDaysIndicator(event?.eventType?.name);

  const openModal = (isNewPosition: boolean = false) => {
    const changes: Partial<TailwindNewInfoSupportDetailedState> = { showEmployeeSelectionModal: true };
    if (isNewPosition) changes.newPosition = isNewPosition;
    setState(changes);
  };

  useEffect(() => {
    const currentlyRequestedDates = eventNewModelPositions.reduce((prevVal, acc) => prevVal + Number(acc['plannedDays']), 0);
    const completed = requestedManDays === currentlyRequestedDates;
    setState({
      arePlannedDaysCompleted: completed,
      warningText: completed ? '' : `You have Requested ${requestedManDays} man Day(s) and have planned ${currentlyRequestedDates} Day(s)`
    });
  }, [eventNewModelPositions, requestedManDays]);

  const closeModal = () => setState({ showEmployeeSelectionModal: false });

  const onEmployeesSelected = (employees: UserDto[]) => {
    const employee = employees.firstOrDefault();
    if (employee == null) return;
    if (newPosition) onNewPosition(employee, { from: requestStartDate, to: requestEndDate });
    else {
      const eventNewModelPositions = props.eventNewModelPositions.map((eventNewModelPosition, i) =>
        userChangeIndex === i
          ? {
              ...eventNewModelPosition,
              userLocationId: employee.roles.find(({ role }) => role.name === 'Employee').location.id,
              userId: employee.id,
              user: employee
            }
          : eventNewModelPosition
      );
      onChange({ ...initialItem, eventNewModelPositions });
    }

    setState({ newPosition: false, userChangeIndex: -1 });
  };

  const changeEmployeeHandler = (idx: number) => setState({ userChangeIndex: idx, showEmployeeSelectionModal: true });

  const removeEventNewModelPositionHandler = (index: number) => {
    const eventNewModelPositions = props.eventNewModelPositions.filter((_, i) => i !== index);
    onChange({ ...initialItem, eventNewModelPositions });
  };

  // const formatInput = (e: any) => {
  //   let checkIfNum;
  //   if (e.key !== undefined) {
  //     // Check if it's a "e", ".", "+" or "-"
  //     checkIfNum = e.key === 'e' || e.key === '.' || e.key === '+' || e.key === '-';
  //   } else if (e.keyCode !== undefined) {
  //     // Check if it's a "e" (69), "." (190), "+" (187) or "-" (189)
  //     checkIfNum = e.keyCode === 69 || e.keyCode === 190 || e.keyCode === 187 || e.keyCode === 189;
  //   }
  //   return checkIfNum && e.preventDefault();
  // };

  const handleTravelDays = (idx: number, property: keyof TravelRangeDto, period: DateTimePeriod) => {
    let eventNewModelPositions: EventPositionDto[];
    eventNewModelPositions = props.eventNewModelPositions.map((newSupportPos, i) => {
      if (i === idx) {
        const newSPo = { ...newSupportPos } as EventPositionDto;
        if (newSPo.travelDays == null) newSPo.travelDays = { departure: { from: null, to: null }, arrival: { from: null, to: null } };
        if (property === 'departure') {
          if (period.from !== props.eventNewModelPositions[idx].travelDays?.departure?.from) newSPo.travelDays.departure.from = period.from;
          if (period.to !== props.eventNewModelPositions[idx].travelDays?.departure?.to) newSPo.travelDays.departure.to = period.to;
        } else if (property === 'arrival') {
          if (period.from !== props.eventNewModelPositions[idx].travelDays?.arrival?.from) newSPo.travelDays.arrival.from = period.from;
          if (period.to !== props.eventNewModelPositions[idx].travelDays?.arrival?.to) newSPo.travelDays.arrival.to = period.to;
        }
        return newSPo;
      } else return newSupportPos;
    });

    eventNewModelPositions && onChange({ ...initialItem, eventNewModelPositions });
  };

  const datesChangeHandler = ({ from, to }: DateTimePeriod, idx: number, travelDays: boolean = false) => {
    let eventNewModelPositions: EventPositionDto[];
    const fromDate = travelDays ? 'travelDateFrom' : 'startDate';
    const toDate = travelDays ? 'travelDateTo' : 'endDate';
    if (travelDays) {
      if (from !== props.eventNewModelPositions[idx][fromDate])
        eventNewModelPositions = props.eventNewModelPositions.map((newSupportPos, i) =>
          i === idx ? { ...newSupportPos, [fromDate]: from } : newSupportPos
        );
      else if (to !== props.eventNewModelPositions[idx][toDate])
        eventNewModelPositions = props.eventNewModelPositions.map((newSupportPos, i) =>
          i === idx ? { ...newSupportPos, [toDate]: to } : newSupportPos
        );
    } else {
      if (from !== props.eventNewModelPositions[idx][fromDate])
        eventNewModelPositions = props.eventNewModelPositions.map((newSupportPos, i) =>
          i === idx
            ? {
                ...newSupportPos,
                [fromDate]: from,
                plannedDays: moment(from).isSameOrBefore(moment(props.eventNewModelPositions[idx][toDate]))
                  ? moment(props.eventNewModelPositions[idx][toDate]).diff(moment(from), 'days') + 1
                  : 0
              }
            : newSupportPos
        );
      else if (to !== props.eventNewModelPositions[idx][toDate])
        eventNewModelPositions = props.eventNewModelPositions.map((newSupportPos, i) =>
          i === idx
            ? {
                ...newSupportPos,
                [toDate]: to,
                plannedDays: moment(to).isSameOrAfter(moment(props.eventNewModelPositions[idx][fromDate]))
                  ? moment(to).diff(moment(props.eventNewModelPositions[idx][fromDate]), 'days') + 1
                  : 0
              }
            : newSupportPos
        );
    }

    eventNewModelPositions && onChange({ ...initialItem, eventNewModelPositions });
  };

  const inputChangeHandler = (property: string, value: any, idx: number) => {
    let eventNewModelPositions;
    eventNewModelPositions = props.eventNewModelPositions.map((supportPos, i) =>
      i === idx ? { ...supportPos, [property]: value } : supportPos
    );

    eventNewModelPositions && onChange({ ...initialItem, eventNewModelPositions });
  };

  const handleOnPatternMachinesChange = ({ pattern, machines }: PatternMachinesViewModel) => {
    let patternId;
    let patternName;
    let machineModels;

    patternId = pattern?.id ?? null;
    patternName = pattern?.title ?? null;
    machineModels = (machines || []).map(({ cluster, equipmentType, machineModel, machineUnits, oem, plcTypes, hasAvailablePlcTypes }) => ({
      machineRelatedClusterId: cluster?.id,
      machineRelatedClusterName: cluster?.title,
      equipmentTypeId: equipmentType?.id,
      equipmentTypeName: equipmentType?.title,
      oemId: oem?.id,
      oemName: oem?.title,
      machineModelId: machineModel?.id,
      machineModelName: machineModel?.title,
      plcTypeRequestMachines: plcTypes,
      machineUnitRequestMachines: machineUnits,
      hasAvailablePlcTypes: hasAvailablePlcTypes
    }));

    onChange({ ...initialItem, patternId, patternName, machineModels });
  };

  return (
    <>
      <div>
        <label className="text-sm text-gray-700">{t('Dates')}</label>
        <TailwindPeriodInput readOnly={true} onChange={period => {}} icon={false} value={{ from: requestStartDate, to: requestEndDate }} />
      </div>

      <div>
        <div className="form__event-details-tab__mr__pattern form__event-details-tab__element mr-table-component__common-styles">
          <TailwindPatternMachines
            readOnly={readonly}
            value={patternMachines}
            onChange={handleOnPatternMachinesChange}
            loadPatternsOnOpen={true}
            profession={supportPositionRoleId ? { id: supportPositionRoleId, title: '' } : null}
          />
        </div>
      </div>

      <div className="supppor-details__item-main-segment">
        <label className="text-sm text-gray-700">{t('Role')}</label>
        <TailwindProfessionEditor
          readOnly
          placeholder={t('Role')}
          value={supportPositionRoleId ? { id: supportPositionRoleId, title: '' } : null}
          onChange={role => {}}
        />
      </div>

      <div>
        <label className="text-sm text-gray-700">{t('Requested HC')}</label>
        <input type="number" className="w-full border border-gray-300 p-2 rounded bg-gray-100" value={positionsRequested} disabled />
      </div>

      <div>
        <label className="text-sm text-gray-700">{t('Requested Man Days')}</label>
        {hideWorkingDaysIndicator ? (
          <input disabled type="number" className="w-full border border-gray-300 p-2 rounded bg-gray-100" value={`${requestedManDays}`} />
        ) : (
          <div className="flex items-center gap-2">
            <input disabled type="number" className="flex-1 border border-gray-300 p-2 rounded bg-gray-100" value={`${requestedManDays}`} />
            <span className="whitespace-nowrap">w/d</span>
          </div>
        )}
      </div>

      {!hideWorkingManHours && (
        <div>
          <label className="text-sm text-gray-700">{t('Requested Working Man hours')}</label>
          <input
            disabled
            className="w-full border border-gray-300 p-2 rounded bg-gray-100"
            type="number"
            onChange={value => {}}
            value={`${requestedWorkingManHours}`}
          />
        </div>
      )}

      <div>
        <label className="text-sm text-gray-700">{t('Theoretical Cost')}</label>
        <div className="flex items-center gap-2">
          <input
            disabled
            className="w-full border border-gray-300 p-2 rounded bg-gray-100"
            type="number"
            step="0.01"
            min="0"
            onInput={e => {
              const value = e.currentTarget.value;
              if (value.includes('.')) {
                const decimals = value.split('.')[1];
                if (decimals.length > 2) {
                  e.currentTarget.value = Number(value).toFixed(2);
                }
              }
            }}
            onChange={value => {}}
            value={`${theoreticalCost}`}
          />
          <span className="whitespace-nowrap">$</span>
        </div>
      </div>

      <div>
        <button
          className={`w-full ${readonly ? 'bg-gray-600' : 'bg-primary-600'} text-white py-2 rounded mt-2`}
          disabled={readonly}
          onClick={() => openModal(true)}
        >
          {t('Add Instructor')}
        </button>
      </div>

      <div>
        {!arePlannedDaysCompleted && (
          <div
            className="flex items-center p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
            role="alert"
          >
            <svg
              className="shrink-0 inline w-4 h-4 me-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
            </svg>
            <span className="sr-only">Info</span>
            <div>{warningText}</div>
          </div>
        )}
      </div>
      <div>
        <div className="form__event-details-tab__mr__pattern form__event-details-tab__element mr-table-component__common-styles">
          {(machineModels || []).length > 0 && (
            <TailwindEventNewModelPositionComponent
              eventNewModelPositions={eventNewModelPositions || []}
              readonly={readonly}
              isHideEditButton={isHideEditButton}
              datesChangeHandler={datesChangeHandler}
              inputChangeHandler={inputChangeHandler}
              changeEmployeeHandler={changeEmployeeHandler}
              //formatInput={formatInput}
              removeEventNewModelPositionHandler={removeEventNewModelPositionHandler}
              handleTravelDays={handleTravelDays}
              supportPositionId={id}
              machine={machineModels[0].machineModelId}
              pattern={patternId ?? ''}
              //eventFormStore={eventFormStore}
              event={event}
            />
          )}
        </div>
      </div>

      <div>
        <div>
          <div className="events-support-details__main-detail">
            {showEmployeeSelectionModal && (
              <TailwindChooseStudentsView
                maxSelection={1}
                showSFPositionFields
                showPositionCodeFields
                alreadySelectedUserIds={(eventNewModelPositions || []).map(x => x.user).map(x => x.id)}
                students={(eventNewModelPositions || []).map(x => x.user)}
                onAddParticipants={onEmployeesSelected}
                onCloseUsersModal={closeModal}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default withTranslation()(React.memo(TailwindNewInfoSupportDetailed));
